import TitleBlock from '@anm/components/TitleBlock';
import styled from 'styled-components';

export const TitleBlockWrapper = styled(TitleBlock)`
  margin-bottom: 24px;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;

  font-size: 14px;
  line-height: 22px;
  color: #292a2b;

  > * {
    margin-bottom: 8px;
  }
`;

const Wrapper = styled.div``;

export default Wrapper;
